import { useEffect } from 'react';
import { Button } from '../ui/Button';

export function CelebrationOverlay({
  phrase,
  onClose,
}: {
  phrase: string;
  onClose: () => void;
}) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape' || e.key === 'Enter') onClose();
    }
    window.addEventListener('keydown', onKey);
    const t = window.setTimeout(onClose, 6000);
    return () => {
      window.removeEventListener('keydown', onKey);
      window.clearTimeout(t);
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-live="polite"
      onClick={onClose}
    >
      <div
        className="w-full max-w-[480px] rounded border border-border bg-bg px-7 py-8 shadow-xl text-center"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="font-caps italic text-[11px] uppercase tracking-[0.18em] text-muted mb-4"
        >
          Задание закрыто
        </div>
        <p
          className="font-display text-[28px] leading-[1.15] font-medium mb-6"
          style={{ fontVariationSettings: '"opsz" 96, "SOFT" 15' }}
        >
          {phrase}
        </p>
        <Button onClick={onClose} className="h-9 px-6">
          Отлично
        </Button>
      </div>
    </div>
  );
}
